module.exports = __webpack_public_path__ + "img/3.25d3f2fd.jpg";